import { ChevronLeft, VolumeOff } from "lucide-react";
import { Button } from "@primitives/button";

import { useTranslation } from "react-i18next";
import ChatMenu from "./chat-menu/ChatMenu";
import { useNavigationState } from "@/zustand/NavigationState";
import { useNavigate } from "react-router-dom";
import { CHAT_HUB_ID } from "@/config/constants";

import ChatAvatar from "@/components/shared/ChatAvatar";

import { ChatType } from "@/server/types/chat";
import CallButtons from "@/components/chat/middle-column/call/CallButtons";
import GuestInviteButton from "@/components/chat/middle-column/call/GuestInviteButton";
import { cn } from "@/lib/utils";
import { featureFlags } from "@/config/featureFlags";

// TO DO => TEMPORARY Passing subscribed props - check init status
export default function ChatPlaygroundHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const activeChatId = useNavigationState((state) => state.activeChatId);
  const activeChatName = useNavigationState((state) => state.activeChatName);
  const activeChatType = useNavigationState((state) => state.activeChatType);
  const activeChatHubId = useNavigationState((state) => state.activeChatHubId);
  const activeChatAvatar = useNavigationState(
    (state) => state.activeChatAvatar,
  );
  const activeChatMemberCount = useNavigationState(
    (state) => state.activeChatMemberCount,
  );
  const activeChatMuted = useNavigationState((state) => state.activeChatMuted);
  const toggleChatDetails = useNavigationState(
    (state) => state.toggleChatDetails,
  );

  const isChatWithArchitect =
    activeChatType === ChatType.GROUP && activeChatHubId === CHAT_HUB_ID;

  return (
    <div
      className={cn(
        "flex h-middleColumnHeaderHeight items-center border-b border-primary/20 px-4 align-middle lg:px-6",
      )}
    >
      {/* NAVIGATE BACK FROM CHAT VIEW */}
      <Button
        className="mr-2 block lg:hidden"
        size="icon"
        variant="ghost"
        onClick={() => navigate("/", { replace: true })}
      >
        <ChevronLeft />
      </Button>
      {/* CHAT AVATAR */}
      {isChatWithArchitect && !activeChatAvatar?.attachmentId ? (
        <img
          src="/icons/logo-architect.svg"
          alt="ORION"
          className="size-7 invert dark:invert-0"
        />
      ) : (
        <ChatAvatar
          chatId={activeChatId || ""}
          chatName={activeChatName}
          attachmentId={activeChatAvatar?.attachmentId}
          secondMemberId={activeChatAvatar?.secondMemberId}
        />
      )}

      {/* CHAT TITLE */}
      <div className="ml-2 flex flex-row items-center gap-2 truncate align-middle">
        <div>{activeChatMuted && <VolumeOff className="size-3" />}</div>
        <div
          className="flex cursor-pointer flex-col truncate"
          onClick={() => toggleChatDetails()}
        >
          <h2 className="truncate text-lg font-semibold leading-tight">
            {activeChatName}
          </h2>
          {activeChatType === ChatType.GROUP && (
            <h3 className="truncate text-sm font-normal leading-tight text-muted-2">
              {activeChatMemberCount.toLocaleString()} {t("members")}
            </h3>
          )}
        </div>
      </div>
      {/* CHAT MENU */}
      <div className="ml-auto flex items-center gap-7">
        {featureFlags.guestInvitesEnabled && !isChatWithArchitect && (
          <GuestInviteButton />
        )}
        {!isChatWithArchitect && <CallButtons />}

        <ChatMenu />
      </div>
    </div>
  );
}
